import { useEffect, useState } from "react";

// Anti-piracy watermark for embedded video players.
// - Static WBA logo + text ("Wall Board Academy — Milano")
// - Cycles through the 4 corners every 20 seconds so post-production cropping
//   cannot permanently remove the mark without ruining the video.
// - `pointer-events-none` so it never interferes with the underlying player.
const CORNERS = [
  { top: "auto",  right: "12px",  bottom: "12px", left: "auto"  }, // bottom-right
  { top: "12px",  right: "auto",  bottom: "auto", left: "12px"  }, // top-left
  { top: "auto",  right: "auto",  bottom: "12px", left: "12px"  }, // bottom-left
  { top: "12px",  right: "12px",  bottom: "auto", left: "auto"  }, // top-right
];

export default function VideoWatermark({ testId = "video-watermark" }) {
  const [corner, setCorner] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setCorner((c) => (c + 1) % CORNERS.length), 20000);
    return () => clearInterval(t);
  }, []);
  const pos = CORNERS[corner];
  return (
    <div
      data-testid={testId}
      className="pointer-events-none absolute z-10 flex items-center gap-2 rounded-sm bg-black/35 px-2.5 py-1.5 backdrop-blur-sm transition-all duration-700 ease-in-out"
      style={{ ...pos, opacity: 0.85 }}
    >
      <img
        src="/logos/logo_navbar.png"
        alt="WBA"
        className="h-7 w-7 object-contain md:h-9 md:w-9"
        draggable={false}
      />
      <span className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-white md:text-[11px]">
        Wall Board <span className="text-cyan">Academy</span> — Milano
      </span>
    </div>
  );
}
